export const getBase64FromUrl = async (url:any) => {
    return new Promise((resolve,reject) => {
      const reader = new FileReader();
      if (reader) {
        reader.readAsDataURL(url);
        reader.onloadend = () => {
          const base64data = reader.result;
          
          resolve(base64data);
        };
        reader.onerror = (error) => {
          
          reject(error);
        };
      }
    });
  };